const BANNER_DOMAIN = 'banner'
const BANNER_STATE = {
  message: null,
  type: null,
  onClick: null
}

const BANNER_ACTION = {
  RESET: 'BANNER_RESET',
  SUCCESS: 'BANNER_SUCCESS',
  ERROR: 'BANNER_ERROR'
}

export {
  BANNER_ACTION,
  BANNER_DOMAIN,
  BANNER_STATE
}
